import PropTypes from "prop-types";
import { idPropType } from "./id-prop-type";

export const reservationPropType = PropTypes.shape({
  id: idPropType,
  backupHoldId: idPropType,
  date: PropTypes.string,
  duration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  price: PropTypes.object,
  primaryHoldId: idPropType,
  zipCode: PropTypes.string,
  backupSku: PropTypes.object,
  primarySku: PropTypes.object,
  user: PropTypes.object,
});
